import { instance } from '../../axios/AxiosInstance';
import type { AuthorRow, ListResponse } from '../Settings/lists/singleTableListSupport';

const PATH = 'authors';

export async function fetchAuthors(): Promise<AuthorRow[]> {
  const { data } = await instance.get<ListResponse>(PATH);
  return Array.isArray(data.data) ? (data.data as AuthorRow[]) : [];
}

export async function createAuthor(body: Record<string, unknown>): Promise<void> {
  await instance.post(PATH, body);
}

export async function updateAuthor(body: Record<string, unknown>): Promise<void> {
  await instance.put(PATH, body);
}
